// extracted by mini-css-extract-plugin
export default {"header":"header__MWUxN","content":"content__NmEzO"};